// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaResetPassword":"MyMazdaResetPassword__MyMazdaResetPassword___3dJvp","MyMazdaResetPasswordForm":"MyMazdaResetPassword__MyMazdaResetPasswordForm___2BQlS"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/MyMazdaResetPassword/MyMazdaResetPassword.less
// module id = 1184
// module chunks = 0 1